module.exports = __webpack_public_path__ + "img/lanzhou.68f10475.jpg";